import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { TemplateConfiguration } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createTemplateConfigurationApi, templateConfigurationKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Fetches a single TemplateConfiguration by id (GET /template-configurations/:id).
 *
 * Enabled only when `configId` is non-null (edit mode).
 * Keyed by `templateConfigurationKeys.detail(id)` so that on success of the
 * `useUpdateShipper` mutation we can invalidate this exact entry.
 */
export function useTemplateConfiguration(configId: string | null): UseQueryResult<TemplateConfiguration> {
  const client = useApiClient('deliveries');
  const api = createTemplateConfigurationApi(client);

  return useQuery<TemplateConfiguration>({
    enabled: configId !== null,
    gcTime: LIST_GC_TIME_MS,
    queryFn: (): Promise<TemplateConfiguration> => api.getTemplateConfiguration(configId as string),
    queryKey: templateConfigurationKeys.detail(configId ?? ''),
    staleTime: LIST_STALE_TIME_MS,
  });
}
